module.exports = __webpack_public_path__ + "img/bg.7b4e18e0.png";